module.exports = __webpack_public_path__ + "img/flying.94d3ed15.png";